import * as React from 'react';
import { lazyLoad } from '../../../utils/loadable';

export const SentinelPage = props => {
  return lazyLoad(
    () => import('./index'),
    module => module.SentinelPage,
    { fallback: <div></div> },
  )(props);
};
